import { Box } from "@mui/material";
import "./ConfigurationDrawer.scss";
import { Button } from "@chr/eds-react";
import { ConfigurationDrawerButtonsProps } from "./ConfigurationDrawerProps";
import { useTranslation } from "@chr/online-shared-ui-localizations";

export const ConfigurationDrawerButtons = ({
    updateWidget,
    cancelChanges
}: ConfigurationDrawerButtonsProps) => {
  const translate = useTranslation();
  
  return (
      <Box className="configuration-buttons">
          <Button 
              data-testid="modal-save"
              buttonText={translate('Save')}
              variant="primary"
              onClick={updateWidget}
              fullWidth
          />
          <Button 
              data-testid="modal-cancel"
              buttonText={translate('Cancel')}
              variant="secondary"
              onClick={cancelChanges}
              fullWidth
          />
      </Box>
  );
}

export default ConfigurationDrawerButtons;